import cookies, { cookieDomain, cookiePath } from './cookies';
import { cookies as cookieKeys } from '../config';

function set(arr) {
  if (arr.length > 0) {
    cookies.setItem(
      cookieKeys.BA_PREFS,
      JSON.stringify(arr),
      null,
      cookiePath,
      cookieDomain
    );
  }
}

function get() {
  try {
    if (cookies.hasItem(cookieKeys.BA_PREFS)) {
      const cookieValue = cookies.getItem(cookieKeys.BA_PREFS);
      cookies.removeItem(cookieKeys.BA_PREFS, cookiePath, cookieDomain);
      return JSON.parse(cookieValue);
    }
    return false;
  } catch (err) {
    if (__DEV__) {
      console.error(err);
    }
    return false;
  }
}

export default function(arr) {
  if (!arr) {
    return get();
  }
  set(arr);
}
